import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

const site = 'https://ogbwhats.com'

/**
 * 子页 path 一律带尾斜杠（与 canonical 一致）。
 * 勿使用「path: '/foo' redirect + path: '/foo/' + pathToRegexpOptions.strict」组合，
 * 会在 Vue Router 3 内触发 redirect ↔ match 死循环。
 * 无尾斜杠访问由 beforeEach 单次 replace 到带斜杠路径。
 */
const TRAILING_SLASH_PREFIXES = [
	'/download',
	'/og-whatsapp-vs-gb-whatsapp',
	'/about',
	'/disclaimer',
	'/privacy',
]

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-og',
		meta: {
			appname: 'OGWhatsApp',
			title: 'OG WhatsApp Download | Latest Version APK for 2026 | ogbwhats.com',
			keywords:
				'OG WhatsApp download, OG WhatsApp APK, download OG WhatsApp latest version, OGWhatsApp, OG WhatsApp features',
			description:
				'Get OG WhatsApp APK download guidance for Android: privacy tools, customization, status options, and safety tips. Not affiliated with WhatsApp LLC.',
			link: [{ rel: 'canonical', href: `${site}/` }],
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'OGWhatsApp',
			title: 'Download OG WhatsApp APK — Latest Version Page | ogbwhats.com',
			keywords:
				'OG WhatsApp APK, OG WhatsApp download, download OG WhatsApp latest version, OG WhatsApp APK download',
			description:
				'Download OG WhatsApp APK from our dedicated page: file info, install steps, and notes before you sideload on Android.',
			link: [{ rel: 'canonical', href: `${site}/download/` }],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/og-whatsapp-vs-gb-whatsapp/',
		name: 'en-compare-og-gb',
		meta: {
			appname: 'OGWhatsApp',
			title: 'OG WhatsApp vs GB WhatsApp — Comparison & Which to Choose | ogbwhats.com',
			keywords:
				'OG WhatsApp vs GB WhatsApp, GB WhatsApp vs OG WhatsApp, GB WhatsApp APK download, OG WhatsApp APK',
			description:
				'Compare OG WhatsApp vs GB WhatsApp: features, trade-offs, and safety notes for mod APK users. Independent guide; not official WhatsApp.',
			link: [{ rel: 'canonical', href: `${site}/og-whatsapp-vs-gb-whatsapp/` }],
		},
		component: () => import('@/views/compareOgVsGb.vue'),
	},
	{
		path: '/about/',
		name: 'en-about',
		meta: {
			appname: 'OGWhatsApp',
			title: 'About ogbwhats.com — OG WhatsApp Download Resource',
			keywords: 'ogbwhats.com, OG WhatsApp, about',
			description:
				'What ogbwhats.com is: an independent information and download resource for OG WhatsApp APK — not WhatsApp LLC.',
			link: [{ rel: 'canonical', href: `${site}/about/` }],
		},
		component: () => import('@/views/about.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'en-disclaimer',
		meta: {
			appname: 'OGWhatsApp',
			title: 'Disclaimer — OG WhatsApp APK & Third-Party Software | ogbwhats.com',
			keywords: 'OG WhatsApp disclaimer, mod APK risks',
			description:
				'Disclaimer for third-party WhatsApp mods: risks, limitations, and trademark notice. Read before you sideload.',
			link: [{ rel: 'canonical', href: `${site}/disclaimer/` }],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/privacy/',
		name: 'en-privacy',
		meta: {
			appname: 'OGWhatsApp',
			title: 'Privacy Policy — ogbwhats.com',
			keywords: 'ogbwhats privacy policy',
			description:
				'How ogbwhats.com handles browsing data, cookies, and third-party links when you read about OG WhatsApp download.',
			link: [{ rel: 'canonical', href: `${site}/privacy/` }],
		},
		component: () => import('@/views/privacy.vue'),
	},
]

let routes = []
routes = constRoutesPc

export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})

	// 将 /download 等无尾斜杠 URL 规范为 /download/，避免使用路由表里的 redirect 记录引发死循环
	router.beforeEach((to, from, next) => {
		if (to.path === '/' || to.path.endsWith('/')) {
			return next()
		}
		if (TRAILING_SLASH_PREFIXES.includes(to.path)) {
			return next({
				path: `${to.path}/`,
				query: to.query,
				hash: to.hash,
				replace: true,
			})
		}
		next()
	})

	return router
}
